export default "__VITE_ASSET__BQOzzdVL__"